import script from "./image-viewer-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./image-viewer-modal.vue?vue&type=script&setup=true&lang=ts"

import "./image-viewer-modal.vue?vue&type=style&index=0&id=c00a7d04&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c00a7d04"]])

export default __exports__